
export function initMobileMenu({
    toggleSelector,
    menuSelector,
    closeSelector,
    openClass = 'open'
}) {
    const toggle = document.querySelector(toggleSelector);
    const menu = document.querySelector(menuSelector);
    const close = document.querySelector(closeSelector);

    if (!toggle || !menu || !close) {
        return;
    }

    toggle.addEventListener('click', () => {
        menu.classList.add(openClass);
    });

    close.addEventListener('click', () => {
        menu.classList.remove(openClass);
    });
}